// Reviews V5 (30/09/26): THE source line of a review card — source NAME → icon → date (dd/MM/yy), RTL reading order.
// ONE component for the public card (components/ReviewsList.tsx), the pro page (app/[catSlug]/[proSlug]/page.tsx) and the admin card (app/admin/professionals/page.tsx) —
// bughunter 30/09: the admin card showed the date without the source. The reviewer city is gone for good.
import type { CSSProperties } from 'react';
import { reviewSourceOf, SOURCE_LABEL } from '@/lib/reviewsPreview';
import ReviewSourceIcon from './ReviewSourceIcon';
import { fmtILDate } from '@/lib/israelTime';

/** dd/MM/yy in Israel time — the house door lib/israelTime.ts fmtILDate (the pro page used it; one format for every card). */
export function fmtReviewDate(d?: string | Date | null): string {
  if (!d) return '';
  const s = fmtILDate(d);
  return s && s !== '—' ? s : '';
}

/** variant 'label' (Founder order 30/09/26 — the pro page's card as it was before that day): "המלצה מאומתת מ-Google" + the source icon,
 *  no date (the pro page shows the date under the reviewer's name). Default 'line' (Founder 07/10/26, restored): "המלצה מאומתת מ-Google" → icon → date (list + admin cards). */
export default function ReviewSourceLine({ source, date, className, style, variant = 'line' }: { source: unknown; date?: string | Date | null; className?: string; style?: CSSProperties; variant?: 'line' | 'label' }) {
  const src = reviewSourceOf(source); const d = fmtReviewDate(date);
  if (variant === 'label') return (
    <span className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#64748b', ...style }}>
      <span>{SOURCE_LABEL[src]}</span>
      <ReviewSourceIcon source={src} />
    </span>
  );
  return (
    <span className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#94a3b8', ...style }}>
      <span>{SOURCE_LABEL[src]}</span>
      <ReviewSourceIcon source={src} size={12} />
      {d && <><span aria-hidden="true">·</span><bdi dir="ltr">{d}</bdi></>}
    </span>
  );
}
